import { render, staticRenderFns } from "./user-primary-group.vue?vue&type=template&id=b0cf4270&"
import script from "./user-primary-group.vue?vue&type=script&lang=ts&"
export * from "./user-primary-group.vue?vue&type=script&lang=ts&"
import style0 from "./user-primary-group.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports